import { render } from "./petunjuk_text.vue?vue&type=template&id=003e928e&scoped=true"
import script from "./petunjuk_text.vue?vue&type=script&lang=js"
export * from "./petunjuk_text.vue?vue&type=script&lang=js"

import "./petunjuk_text.vue?vue&type=style&index=0&id=003e928e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-003e928e"]])

export default __exports__